module.exports = __webpack_public_path__ + "static/media/image1.d616b8a6.png";